import { createSlice } from '@reduxjs/toolkit';

import { estelamSabtAhvalThunk } from 'Feature/Common/Common/Actions/Thunks/estelamSabtAhvalThunk';
import { getActiveModdatHayeBimehNameh } from 'Feature/Common/Common/Actions/Thunks/getActiveModdatHayeBimehNameh';
import { getAddressWithPostCodeThunk } from 'Feature/Common/Common/Actions/Thunks/getAddressWithPostCodeThunk';
import { getAllCountries } from 'Feature/Khodro/ShakhsSales/Thunks/getAllCountries';
import { getAllTarhHayeSodoorByNoeBimeh } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTarhHayeSodoorByNoeBimeh';
import LabelValueType from 'Shared/Core/Common/Models/LabelValueType';

import {
  GetAllAnvaeSherkatBimeh,
  addBimehNamehMasooliatMadaniToOrder,
  createShenasehPardakht,
  estelamMasooliatMadaniOmumi,
  getActivePoosheshHayeMasooliatMadani,
  getActiveTaahodatHazinehPezeshki,
  getLastMarjaeDieh,
  getMozuatFaaliatOmumi,
} from './action';
import { IMasooliatMadaniEstelamAndSodoorState } from './model';

const initialState: IMasooliatMadaniEstelamAndSodoorState = {
  estelamAndSodoorData: {
    bimehNameh: null,
    pooshesh: null,
    moredBimehNameh: null,
    bimehNamehGhabl: null,
    mahalEsteghrar: null,
    bimehGozar: null,
    address: null,
  },
  anvaeSherkatBimeh: {
    data: [],
    loading: false,
  },
  estelamSabtAhval: {
    loading: false,
  },
  estelam: {
    loading: false,
    result: null,
  },
  codeposti: {
    loading: false,
  },

  tarhHayeSodoor: {
    loading: false,
    data: [],
  },
  taahodatHazinehPezeshki: {
    loading: false,
    data: [],
  },
  wizard: {
    beginStep: 1,
    currentStep: 1,
    endStep: 10,
  },
  marjaeDieh: {
    loading: false,
    data: null,
  },
  mozuFaaliatOmumi: {
    loading: false,
    data: [],
  },
  poosheshHayeMasooliatMadani: {
    loading: false,
    data: [],
  },
  isSuccess: false,
  haghBimehPardakhti: 0,
  moddatHayeBimehNameh: {
    loading: false,
    data: [],
  },
  addToOrderResponse: {
    loading: false,
  },
  getCodeShenasehPardakhtMasooliatMadaniResult: {
    loading: false,
    data: null,
  },
  isMablaghKharidBimehNamehMoreThanHaghBimeh: false,
  countries: {
    loading: false,
    data: [],
  },
};

export const masooliatMadaniEstelamAndSodoorSlice = createSlice({
  name: 'MasooliatMadani/EstelamAndSodoor',
  initialState: initialState,
  reducers: {
    clearEstelamAndSodoorData: (state) => {
      state.estelamAndSodoorData = initialState.estelamAndSodoorData;
      state.wizard = initialState.wizard;
      state.estelam = initialState.estelam;
      state.estelamSabtAhval = initialState.estelamSabtAhval;
      state.getCodeShenasehPardakhtMasooliatMadaniResult = initialState.getCodeShenasehPardakhtMasooliatMadaniResult;
      state.haghBimehPardakhti = initialState.haghBimehPardakhti;
    },
    setBimehNamehData: (state, action) => {
      state.estelamAndSodoorData.bimehNameh = action.payload;
    },
    setPoosheshData: (state, action) => {
      state.estelamAndSodoorData.pooshesh = action.payload;
    },
    setMoredBimehData: (state, action) => {
      state.estelamAndSodoorData.moredBimehNameh = action.payload;
    },
    setBimehNamehGhabl: (state, action) => {
      state.estelamAndSodoorData.bimehNamehGhabl = action.payload;
    },
    setMahalEsteghrar: (state, action) => {
      state.estelamAndSodoorData.mahalEsteghrar = action.payload;
    },
    setBimehGozar: (state, action) => {
      state.estelamAndSodoorData.bimehGozar = action.payload;
    },
    setAddressData: (state, action) => {
      state.estelamAndSodoorData.address = action.payload;
    },
    setIsMablaghKharidBimehNamehMoreThanHaghBimeh: (state, action) => {
      state.isMablaghKharidBimehNamehMoreThanHaghBimeh = action.payload;
    },
    clearPoosheshFotAndSumHazinehPezeshkiData: (state) => {
      if (state.estelamAndSodoorData.pooshesh) {
        state.estelamAndSodoorData.pooshesh.fotVaNaghsOzv = null;
        state.estelamAndSodoorData.pooshesh.sumHazinehPezeshki = null;
      }
    },

    clearEstelamResult: (state) => {
      state.estelam.result = null;
    },
    wizardNextStep: (state) => {
      const nextStep = state.wizard.currentStep + 1;
      if (nextStep <= state.wizard.endStep) {
        state.wizard.currentStep = nextStep;
      }
    },
    wizardPreviousStep: (state) => {
      const previousStep = state.wizard.currentStep - 1;
      if (previousStep >= state.wizard.beginStep) {
        state.wizard.currentStep = previousStep;
      }
    },
    setHaghBimehPardakhtiCommand: (state, action) => {
      state.haghBimehPardakhti = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getLastMarjaeDieh.pending, (state) => {
        state.marjaeDieh.loading = true;
      })
      .addCase(getLastMarjaeDieh.fulfilled, (state, action) => {
        state.marjaeDieh.data = action.payload;
        state.marjaeDieh.loading = false;
      })
      .addCase(getLastMarjaeDieh.rejected, (state) => {
        state.marjaeDieh.loading = false;
      });
    builder
      .addCase(getMozuatFaaliatOmumi.pending, (state) => {
        state.mozuFaaliatOmumi.loading = true;
      })
      .addCase(getMozuatFaaliatOmumi.fulfilled, (state, action) => {
        state.mozuFaaliatOmumi.data = action.payload;
        state.mozuFaaliatOmumi.loading = false;
      })
      .addCase(getMozuatFaaliatOmumi.rejected, (state) => {
        state.mozuFaaliatOmumi.loading = false;
      });
    builder
      .addCase(getActivePoosheshHayeMasooliatMadani.pending, (state) => {
        state.poosheshHayeMasooliatMadani.loading = true;
      })
      .addCase(getActivePoosheshHayeMasooliatMadani.fulfilled, (state, action) => {
        state.poosheshHayeMasooliatMadani.data = action.payload;
        state.poosheshHayeMasooliatMadani.loading = false;
      })
      .addCase(getActivePoosheshHayeMasooliatMadani.rejected, (state) => {
        state.poosheshHayeMasooliatMadani.loading = false;
      });
    builder
      .addCase(estelamMasooliatMadaniOmumi.pending, (state) => {
        state.estelam.loading = true;
      })
      .addCase(estelamMasooliatMadaniOmumi.fulfilled, (state, action) => {
        state.estelam.loading = false;
        state.isSuccess = false;
        if (action.payload !== undefined) {
          state.estelam.result = action.payload;
          state.isSuccess = true;
        }
        return state;
      })
      .addCase(estelamMasooliatMadaniOmumi.rejected, (state) => {
        state.estelam.loading = false;
      });
    builder
      .addCase(getAllTarhHayeSodoorByNoeBimeh.pending, (state) => {
        state.tarhHayeSodoor.loading = true;
      })
      .addCase(getAllTarhHayeSodoorByNoeBimeh.fulfilled, (state, action) => {
        state.tarhHayeSodoor.loading = false;
        state.isSuccess = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.tarhHayeSodoor.data = list;
          state.isSuccess = true;
        }
        return state;
      })
      .addCase(getAllTarhHayeSodoorByNoeBimeh.rejected, (state) => {
        state.tarhHayeSodoor.loading = false;
      });
    builder
      .addCase(getActiveTaahodatHazinehPezeshki.pending, (state) => {
        state.taahodatHazinehPezeshki.loading = true;
      })
      .addCase(getActiveTaahodatHazinehPezeshki.fulfilled, (state, action) => {
        state.taahodatHazinehPezeshki.loading = false;
        state.isSuccess = false;
        if (action.payload !== undefined) {
          state.taahodatHazinehPezeshki.data = action.payload;
          state.isSuccess = true;
        }
        return state;
      })
      .addCase(getActiveTaahodatHazinehPezeshki.rejected, (state) => {
        state.taahodatHazinehPezeshki.loading = false;
      });

    builder
      .addCase(getActiveModdatHayeBimehNameh.pending, (state) => {
        state.moddatHayeBimehNameh.loading = true;
      })
      .addCase(getActiveModdatHayeBimehNameh.fulfilled, (state, action) => {
        state.moddatHayeBimehNameh.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.id,
            label: item.title,
          }));
          state.moddatHayeBimehNameh.data = list;
        }
        return state;
      })
      .addCase(getActiveModdatHayeBimehNameh.rejected, (state) => {
        state.moddatHayeBimehNameh.loading = false;
      });
    builder
      .addCase(getAddressWithPostCodeThunk.pending, (state) => {
        state.codeposti.loading = true;
      })
      .addCase(getAddressWithPostCodeThunk.fulfilled, (state) => {
        state.codeposti.loading = false;
      })
      .addCase(getAddressWithPostCodeThunk.rejected, (state) => {
        state.codeposti.loading = false;
      });
    builder
      .addCase(GetAllAnvaeSherkatBimeh.pending, (state) => {
        state.anvaeSherkatBimeh.loading = true;
      })
      .addCase(GetAllAnvaeSherkatBimeh.fulfilled, (state, action) => {
        state.anvaeSherkatBimeh.loading = false;
        if (action.payload !== undefined) {
          const list: any[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.bimehMarkaziTitle,
          }));
          state.anvaeSherkatBimeh.data = list;
        }
        return state;
      })
      .addCase(GetAllAnvaeSherkatBimeh.rejected, (state) => {
        state.anvaeSherkatBimeh.loading = false;
      });

    builder
      .addCase(estelamSabtAhvalThunk.pending, (state) => {
        state.estelamSabtAhval.loading = true;
      })
      .addCase(estelamSabtAhvalThunk.fulfilled, (state) => {
        state.estelamSabtAhval.loading = false;
      })
      .addCase(estelamSabtAhvalThunk.rejected, (state) => {
        state.estelamSabtAhval.loading = false;
      });

    builder
      .addCase(addBimehNamehMasooliatMadaniToOrder.pending, (state) => {
        state.addToOrderResponse.loading = true;
      })
      .addCase(addBimehNamehMasooliatMadaniToOrder.fulfilled, (state) => {
        state.addToOrderResponse.loading = false;
      })
      .addCase(addBimehNamehMasooliatMadaniToOrder.rejected, (state) => {
        state.addToOrderResponse.loading = false;
      });
    builder
      .addCase(createShenasehPardakht.pending, (state) => {
        state.getCodeShenasehPardakhtMasooliatMadaniResult.loading = true;
      })
      .addCase(createShenasehPardakht.fulfilled, (state, action) => {
        state.getCodeShenasehPardakhtMasooliatMadaniResult.loading = false;

        if (action.payload !== undefined) {
          state.getCodeShenasehPardakhtMasooliatMadaniResult.data = action.payload;
          state.isSuccess = true;
        } else {
          state.isSuccess = false;
        }

        return state;
      })
      .addCase(createShenasehPardakht.rejected, (state) => {
        state.getCodeShenasehPardakhtMasooliatMadaniResult.loading = false;
      });

    builder
      .addCase(getAllCountries.pending, (state) => {
        state.countries.loading = true;
      })
      .addCase(getAllCountries.fulfilled, (state, action) => {
        state.countries.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.countries.data = list;
        }
        return state;
      })
      .addCase(getAllCountries.rejected, (state) => {
        state.countries.loading = false;
      });
  },
});

export const {
  setBimehNamehData,
  setBimehGozar,
  setMahalEsteghrar,
  setHaghBimehPardakhtiCommand,
  clearEstelamResult,
  clearEstelamAndSodoorData,
  wizardNextStep,
  setBimehNamehGhabl,
  setIsMablaghKharidBimehNamehMoreThanHaghBimeh,
  setPoosheshData,
  wizardPreviousStep,
  setAddressData,
  setMoredBimehData,
  clearPoosheshFotAndSumHazinehPezeshkiData,
} = masooliatMadaniEstelamAndSodoorSlice.actions;

export default masooliatMadaniEstelamAndSodoorSlice.reducer;
